// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KIc7","colBig":"styles_colBig__1gFzj","colSmall":"styles_colSmall__3awdv","shopifyNameWrapper":"styles_shopifyNameWrapper__2Tn4b"};